export const MEDIA_QUERY = {
  MAX_WIDTH: '768px',
};

export const ITEM_LAYOUT = {
  labelCol: {
    sm: { span: 24 },
    md: { span: 6 },
    xl: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 24 },
    md: { span: 16 },
    xl: { span: 16 },
  },
};

export const SIGNATURE_LAYOUT = {
  labelCol: {
    sm: { span: 24 },
    md: { span: 4 },
    xl: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 24 },
    md: { span: 20 },
    xl: { span: 20 },
  },
};

export const RADIO_LAYOUT = {
  labelCol: {
    sm: { span: 24 },
    md: { span: 16 },
    xl: { span: 16 },
  },
  wrapperCol: {
    sm: { span: 24 },
    md: { span: 8 },
    xl: { span: 8 },
  },
};

export const QUESTION_RADIO_LAYOUT = {
  labelCol: {
    sm: { span: 24 },
    md: { span: 17 },
    xl: { span: 17 },
  },
  wrapperCol: {
    sm: { span: 24 },
    md: { span: 7 },
    xl: { span: 7 },
  },
};

export const ITEM_FULL_LAYOUT = {
  labelCol: {
    sm: { span: 24 },
    md: { span: 6 },
    xl: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 24 },
    md: { span: 16 },
    xl: { span: 8 },
  },
};

export const CHECKBOX_LAYOUT = {
  wrapperCol: {
    sm: { span: 24 },
    md: { span: 16 },
    xl: { span: 18, offset: 8 },
  },
};

export const CHECKBOX_FULL_LAYOUT = {
  wrapperCol: {
    sm: { span: 24 },
    md: { span: 24 },
    xl: { span: 24 },
  },
};

export const FORM_GRID = {
  WRAPPER_COL: {
    sm: { span: 24 },
    lg: { span: 24 },

    xl: { span: 20, offset: 2 },
  },
  CONTENT_COL: {
    sm: { span: 24 },
    lg: { span: 24 },
    xl: { span: 12 },
  },
  FULL_COL: {
    sm: { span: 24 },
    lg: { span: 24 },
    xl: { span: 24 },
  },
  HALF_COL: {
    sm: { span: 24 },
    md: { span: 24 },
    lg: { span: 20 },
    xl: { span: 15 },
  },
};

export const FORM_GRID_TIME_SLOT = {
  WRAPPER_COL: {
    sm: { span: 24 },
    lg: { span: 12, offset: 3 },
    md: { span: 24, offset: 0 },
    xl: { span: 12, offset: 3 },
  },
  CONTENT_COL: {
    sm: { span: 24 },
    lg: { span: 24 },
    xl: { span: 12 },
  },
};

export const ORGANISATION_SELECT_LAYOUT = {
  labelCol: {
    xs: { span: 10 },
    sm: { span: 10 },
    md: { span: 8 },
    xl: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 12 },
    md: { span: 14 },
    xl: { span: 14 },
  },
};

export const SITE_SELECT_LAYOUT = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 6 },
  },
};
